import RouteDesigner from "@/router/RouteDesigner"
import Authentication from "@/middleware/Authentication"
import Authorization from "@/middleware/Authorization"
import ForceTypes from "@/middleware/ForceTypes"
import SignupComplete from "@/middleware/SignupComplete"
import Guest from "@/middleware/Guest"
import SignupNotComplete from "@/middleware/SignupNotComplete"
import Subscribed from "@/middleware/Subscribed"
import Beneficiary from "@/middleware/Beneficiary"
import Admin from "@/middleware/Admin"
import User from "@/middleware/User"
import NotApp from "@/middleware/NotApp"
import RequiresOnboardingComplete from "@/middleware/RequiresOnboardingComplete"
import SignUpDisabled from "@/middleware/SignUpDisabled"

export const ROUTES = {
  LOGIN: "login",
  REGISTER: "register",
  FORGOT_PASSWORD: "forgot-password",
  FORGOT_PASSWORD_OTP: "forgot-password-otp",
  FORGOT_PASSWORD_FINISH: "forgot-password-finish",
  FORGOT_PASSWORD_FINISHED: "forgot-password-finished",
  DASHBOARD: "dashboard",
  ONBOARDING_PENDING: "onboarding-pending",
  HOME: "home",
  FOLDERS: "folders",
  FILES: "files",
  BENEFICIARIES: "beneficiaries",
  MY_ACCOUNT: "my-account",
  SUPPORT: "support",
  PRIVACY_POLICY: "privacy-policy",
  COOKIE_POLICY: "cookie-policy",
  TERMS_OF_SERVICE: "terms-of-service",

  BENEFICIARY_SIGNUP: "beneficiary-signup",
  BENEFICIARY_FOLDERS: "beneficiary-folders",
  BENEFICIARY_FILES: "beneficiary-files",
  BENEFICIARY_MY_ACCOUNT: "beneficiary-my-account",
  NOT_FOUND: "not-found",

  ADMIN_DASHBOARD: "admin-dashboard",
  ADMIN_MANAGE_USERS: "admin-manage-users",
  ADMIN_MANAGE_BENEFICIARIES: "admin-manage-beneficiaries",
  ADMIN_MANAGE_ADMINS: 'admin-manage-admins',
  QUICK_CHECK_IN: 'quick-check-in'
}

RouteDesigner.setNotFound("Error404Page").layout('Empty')
RouteDesigner.group('', function () {
  RouteDesigner.group('', function () {
    RouteDesigner.route("/login", "LoginPage", ROUTES.LOGIN)
    RouteDesigner.route("/forgot-password", "ForgotPassword", ROUTES.FORGOT_PASSWORD)
    RouteDesigner.route('/forgot-password/finish/:token/:email', "ForgotPasswordFinish", ROUTES.FORGOT_PASSWORD_FINISH)
    RouteDesigner.route('/forgot-password/finished', "ForgotPasswordFinished", ROUTES.FORGOT_PASSWORD_FINISHED).meta({withoutFooter: true})
  })
    .layout("Guest")
    .middleware([Guest])

  RouteDesigner.route("/register", "RegisterPage", ROUTES.REGISTER)
    .middleware([SignUpDisabled, SignupNotComplete])
    .layout("Empty")

  RouteDesigner.group('', function () {
    RouteDesigner.route("/", "HomePage", ROUTES.HOME)
    RouteDesigner.route("/quick-check-in", "QuickCheckinPage", ROUTES.QUICK_CHECK_IN)
    RouteDesigner.route("/terms-of-service", "TermsOfService", ROUTES.TERMS_OF_SERVICE)
    RouteDesigner.route("/privacy-policy", "PrivacyPolicy", ROUTES.PRIVACY_POLICY)
    RouteDesigner.route("/cookie-policy", "CookiePolicy", ROUTES.COOKIE_POLICY)
  })
    .layout("Website")
    .middleware([NotApp])

  RouteDesigner.group('', function () {
    RouteDesigner.route("/dashboard", "DashboardPage", ROUTES.DASHBOARD)
  })
    .middleware([Authorization, RequiresOnboardingComplete, SignupComplete, Subscribed])
    .layout("Auth")

  RouteDesigner.route("/onboarding-pending", "OnboardingPending", ROUTES.ONBOARDING_PENDING)
      .middleware([Authorization, SignupNotComplete])
      .layout("Empty")

  RouteDesigner.group('', function () {
    RouteDesigner.route("/folders", "FoldersPage", ROUTES.FOLDERS)
    RouteDesigner.route("/folders/:folderId/files", "FoldersViewPage", ROUTES.FILES)
    RouteDesigner.route("/beneficiaries", "BeneficiariesPage", ROUTES.BENEFICIARIES)
    RouteDesigner.route("/my-account", "MyAccountPage", ROUTES.MY_ACCOUNT)
    RouteDesigner.route("/support", "SupportPage", ROUTES.SUPPORT)
  })
    .middleware([Authorization, RequiresOnboardingComplete, SignupComplete, Subscribed, User])
    .layout("Auth")

  RouteDesigner.group('/beneficiary', function () {
    RouteDesigner.route("/signup", "BeneficiarySignup", ROUTES.BENEFICIARY_SIGNUP)
      .layout("Empty")
      .middleware([SignupNotComplete])

    RouteDesigner.group('', function () {
      RouteDesigner.route("/folders", "FoldersPage", ROUTES.BENEFICIARY_FOLDERS)
      RouteDesigner.route("/folders/:folderId/files", "FoldersViewPage", ROUTES.BENEFICIARY_FILES)
      RouteDesigner.route("/my-account", "BeneficiaryMyAccountPage", ROUTES.BENEFICIARY_MY_ACCOUNT)
      RouteDesigner.route("/support", "SupportPage", ROUTES.SUPPORT)
    })
      .middleware([Authorization])
      .layout("Auth")
  })
    .middleware([Beneficiary])

  RouteDesigner.group('/admin', function () {
    RouteDesigner.route("/dashboard", "AdminDashboardPage", ROUTES.ADMIN_DASHBOARD)
    RouteDesigner.route("/users", "AdminUsersPage", ROUTES.ADMIN_MANAGE_USERS)
    RouteDesigner.route("/beneficiaries", "AdminBeneficiariesPage", ROUTES.ADMIN_MANAGE_BENEFICIARIES)
    RouteDesigner.route("/admins", "AdminAdminsPage", ROUTES.ADMIN_MANAGE_ADMINS)
  })
    .middleware([Authorization, Admin])
    .layout("Auth")
})
  .layout("Empty")
  .middleware([ForceTypes, Authentication])
  .props()
